import { render, staticRenderFns } from "./CCFooter.vue?vue&type=template&id=2ad829ef&scoped=true"
import script from "./CCFooter.vue?vue&type=script&lang=js"
export * from "./CCFooter.vue?vue&type=script&lang=js"
import style0 from "./CCFooter.vue?vue&type=style&index=0&id=2ad829ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad829ef",
  null
  
)

export default component.exports